<template>
    <div class="pb-2 border-gray-200 sm:flex sm:items-baseline sm:justify-between">
            <div>
                <div class="flex items-baseline gap-2">
                    <h3 :class="size || 'text-2xl'" class="leading-6 font-medium text-gray-900 font-blinker">{{title}}</h3>
                    <div v-if="count">{{[count]}}</div>
                </div>    
                <h4 :class="sizeSub || 'text-lg'" class="leading-6 font-light text-gray-900">{{subTitle}}</h4>
                <slot name="users"></slot>
            </div>
            <div class="mt-3 flex sm:mt-0 sm:ml-4">

                <slot/>
            </div>
        </div>
</template>

<script>
export default {
    name: "PageHeader",
    props:{
        title: String,
        size: String,
        subTitle: String,
        sizeSub: String,
        count: Number,
        
    },

}
</script>
<style scoped>
    .title {
        
    }

</style>
